<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='用户信息管理'></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchHospitalSelect v-model='condition.company' label='单位'></SearchHospitalSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.managesec" filterable placeholder="全部" @change="ManageSecChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">科室：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.section" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.jobnum' label='工号'></SearchNormalText>
          <SearchNormalText v-model='condition.username' label='用户名'></SearchNormalText>
          <SearchRoleSelect v-model='condition.role' label='角色'></SearchRoleSelect>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url="searchUrl" ref="btnSearch"></SearchButton>
          <!-- <ImportButton></ImportButton> -->
          <AddButton url="/system/user/add"></AddButton>
        </div>
        <!--end: Search Form -->
      </div>
      <div class="m-portlet__body">
        <!--begin: Datatable -->
        <el-table v-loading="loading" :data="tableData" stripe style="width: 100%;" size="medium">
          <el-table-column prop="TrueName" label="姓名">
          </el-table-column>
          <el-table-column prop="JobNum" label="工号">
          </el-table-column>
          <el-table-column prop="UserName" label="用户名">
          </el-table-column>
          <el-table-column prop="HosName" label="单位">
          </el-table-column>
          <el-table-column prop="ManageSecName" label="管理单元">
          </el-table-column>
          <el-table-column prop="SecName" label="科室">
          </el-table-column>
          <el-table-column prop="RoleName" label="角色" width="100">
          </el-table-column>
          <el-table-column prop="UserStatus" label="状态" width="80">
            <template slot-scope="scope">
              <el-button @click="UpdateStatus(scope.row, 1)" type="text" size="medium" v-if="scope.row.UserStatus === 0">
                <font style="color: #F56C6C;">停用</font>
              </el-button>
              <el-button @click="UpdateStatus(scope.row, 0)" type="text" size="medium" v-if="scope.row.UserStatus === 1">
                <font style="color: #67C23A;">启用</font>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button @click="Reset(scope.row)" type="text" size="medium">恢复密码</el-button>
              <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
              <el-button @click="Delete(scope.row)" type="text" size="medium">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--end: Datatable -->
        <!--begin: Pager -->
        <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="condition.recordCount">
          </el-pagination>
        </div>
        <!--end: Pager -->

      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: 'UserList',
    data() {
      return {
        condition: {
          token: '',
          truename: '',
          company: '',
          section: '',
          jobnum: '',
          username: '',
          role: '',
          pageSize: 10,
          currentPage: 1,
          recordcount: 0,
          firstSearch: true,
          managesec: '',
          rolelevel: '',
          uname: ''
        },
        secOptions: [],
        managesecOptions: [],
        tableData: null,
        searchUrl: this.$utils.Url.system + '/systemapi/user/list',
        loading: true
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pagesize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      //修改
      Edit: function(row) {
        this.$router.push({
          name: 'UserEdit',
          params: {
            id: row.UserID
          }
        })
      },
      //删除
      Delete: function(row) {
        var args = {
          id: row.UserID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.system + '/systemapi/user/delete', args, row.TrueName, this.$refs.btnSearch
          .Search)
      },
      //重置密码
      Reset: function(row) {
        let v = new Vue()
        v.$confirm('即将初始化 ' + row.TrueName + ' 的密码, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var args = {
            id: row.UserID,
            token: this.condition.token
          }
          this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/user/reset', args, function(data) {
            if (data.Code === 0) {
              v.$message({
                message: '密码已重置',
                type: 'success'
              })
            } else {
              v.$message({
                message: data.Msg + '，' + data.Error,
                type: 'error'
              })
            }
          }, null, null)
        }).catch(() => {})
      },
      //更新状态
      UpdateStatus: function(row, status) {
        let v = new Vue()
        v.$confirm('更改 ' + row.TrueName + ' 的状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var args = {
            id: row.UserID,
            status: status,
            token: this.condition.token
          }
          this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/user/updatestatus', args, function(data) {
            if (data.Code === 0) {
              row.UserStatus = status
              v.$message({
                message: '状态已变更',
                type: 'success'
              })
            } else {
              v.$message({
                message: data.Msg + '，' + data.Error,
                type: 'error'
              })
            }
          }, null, null)
        }).catch(() => {})
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.uname,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      ManageSecChange: function() {
        this.condition.section = ''
        this.secOptions = []
        this.LoadSec()
      },
      LoadSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.uname,
          rolelevel: this.condition.rolelevel,
          mamagesec: this.condition.managesec
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      }
    },
    mounted() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.uname = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.LoadManageSec()
      this.LoadSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style>
</style>
